import classNames from 'classnames'
import propTypes from 'prop-types'

import Link from 'components/Link'


export function Item(props) {
  const Icon = props.icon
  return (
    <li
      title={props.title}
      className={classNames([
        'group transition-all flex items-center justify-center flex-1 overflow-hidden',
        props.className,
      ])}
    >
      <Link
        noPadding
        onClick={props.onClick}
        className={classNames([
          { 'text-primary-600': props.active },
          'flex flex-col space-y-2 items-center w-full',
          props.linkClassName,
        ])}
      >
        {
          Icon &&
          <Icon className={classNames(
            'text-5xl',
            'transition-all',
            ' rounded-full p-2 text-white',
            'group-hover:bg-primary-600',
            {
              'bg-primary-600 text-white': props.active,
              'bg-disabled-400': ! props.active,
            },
          )} />
        }
        {props.children}
      </Link>
    </li>
  )
}

Item.propTypes = {
  className: propTypes.string,
  linkClassName: propTypes.string,
  onClick: propTypes.func,
  active: propTypes.bool,
  icon: propTypes.element,
  title: propTypes.string,
}

Item.defaultProps = {
  active: false,
}


export default function Menu(props) {
  return (
    <nav className={classNames([
      props.containerClassName,
      'bg-white flex items-center w-full z-20 transition-all',
      {'-shadow-md': props.position === 'bottom'},
      {'shadow-md': props.position === 'top'},
    ])}>
      <ul className={classNames([
        'list-none flex flex-1 ml-auto mr-auto max-w-4xl',
        props.className,
      ])}>
        {props.children}
      </ul>
    </nav>
  )
}

Menu.Item = Item

Menu.propTypes = {
  className: propTypes.string,
  containerClassName: propTypes.string,
  position: propTypes.oneOf(['top', 'bottom']),
  children: propTypes.oneOfType([
    propTypes.shape({
      type: propTypes.oneOf([Item]),
    }),
    propTypes.arrayOf(
      propTypes.shape({
        type: propTypes.oneOf([Item]),
      })
    ),
  ]).isRequired,
}

Menu.defaultProps = {
  position: 'bottom',
}
